<p-dialog [visible]="true" [breakpoints]="{'440px': '100%'}" [draggable]="false" [resizable]="true"
  [style]="{width: '40%'}" [baseZIndex]="10000" [modal]="true" [maximizable]="false"
  [ngClass]="{'change-scrollbar-color-darkMode': settings.darkModeSetting, 'change-scrollbar-color': !settings.darkModeSetting}">
  <dialog-header [title]="app.translations.NOT_lbl_Title" [settings]="settings" [icon]="faBell"></dialog-header>  
  <ng-template [ngIf]="notificationGroups.length == 0">
    <div class="row animated fadeIn" [ngStyle]="{'background-color': settings.darkModeSetting ? '#00000099' : '#ededed'}">
      <span class="font15 padding10 text-centre" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
        {{app.translations.NOT_lbl_NoNotifications}}
      </span>
    </div>
  </ng-template>
  <ng-template [ngIf]="notificationGroups.length > 0">
    <div class="row unset-p" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
      <div class="padding10">
        <mat-tab-group class="tabGroup" [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="changeTab($event)"
          [@.disabled]="true">
          <ng-container *ngFor="let group of notificationGroups">
            <mat-tab class="animated fadeIn">
              <ng-template mat-tab-label>
                <span [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                  <fa-icon [icon]="group.icon"></fa-icon>                 
                  {{group.category}}
                </span>
              </ng-template>
            </mat-tab>
          </ng-container>
        </mat-tab-group>
        <ng-container *ngFor="let notificationGroup of notificationGroups; let i = index">
          <ng-template [ngIf]="i == selectedTabIndex">
            <ng-template [ngIf]="notificationGroup.notifications.length > 0">
              <ng-container *ngFor="let notification of notificationGroup.notifications">
                <div class="row animated fadeIn notifications-container"
                  [ngStyle]="{'animation-delay': notification.animationDelay}">
                  <div class="row">
                    <div class="cursorPointer padding10 b-radius" (click)="readNotification(notification)"
                      [ngStyle]="{
                         'border-left': !notification.read ? '2px solid var(--blue)' : '2px solid #eaf1ff',
                         'background-color': (notification.read ? (settings.darkModeSetting ? '#ededed2b' : '#ededed') : (settings.darkModeSetting ? '#eaf1ff63' : '#eaf1ff'))}">
                      <div class="col-12 unset-p">
                        <span class="font16 bold"
                          [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{notification.subject}}</span>
                          <button class="font16 float-right bg-none unset-b">
                            <fa-icon [icon]="faXmark" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textGreen'"
                            (click)="deleteNotification(notification)"></fa-icon>                           
                          </button>
                          <span class="font16 float-right bold" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                            {{notification.date | date:settings.dateFormatSetting + ' HH:mm:ss'}}
                          </span>                                                   
                      </div><br />
                      <div class="col-12 unset-p">
                        <div class="poppins font15" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                          [innerHTML]="notification.body"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-template>
            <ng-template [ngIf]="notificationGroup.notifications.length == 0">
              <div class="row animated fadeIn text-centre padding10">
                <span class="font15 padding15 b-radius"
                  [ngStyle]="{'background-color': settings.darkModeSetting ? '#ededed33' : '#ededed'}"
                  [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                  {{app.translations.NOT_lbl_Empty}}
                </span>
              </div>
            </ng-template>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </ng-template>
</p-dialog>